import React, { useState } from 'react';
import { X, Link2, Check, Copy } from 'lucide-react';

function CopyUrlModal({ point, onClose }) {
  const [copied, setCopied] = useState(false);
  const url = `https://www.fastmaxlima.com/#/entrega/${point.id}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
        onClose();
      }, 1500);
    } catch (error) {
      console.error('Error copying to clipboard:', error);
      alert('Error al copiar URL');
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 font-montserrat" 
      style={{ zIndex: 10000 }}
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-xl shadow-2xl w-full max-w-md"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-blue-600 px-6 py-4 flex items-center justify-between rounded-t-xl">
          <div className="flex items-center gap-3">
            <Link2 className="w-5 h-5 text-white" />
            <h2 className="text-lg font-bold text-white">
              Copiar URL del Punto
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-1 hover:bg-blue-700 rounded-lg transition-colors"
          >
            <X className="w-5 h-5 text-white" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="mb-4">
            <p className="text-sm text-slate-600 mb-2">
              Punto de entrega: <span className="font-bold text-[#B1336E]">#{point.id}</span>
            </p>
            {point.recipient_name && (
              <p className="text-sm text-slate-600">
                {point.recipient_name}
              </p>
            )}
          </div>

          <div className="bg-slate-50 border border-slate-200 rounded-lg p-4 mb-4">
            <p className="text-sm text-slate-800 break-all font-mono">
              {url}
            </p>
          </div>

          <button
            onClick={handleCopy}
            className={`w-full py-3 px-4 rounded-lg font-medium transition-all flex items-center justify-center gap-2 ${
              copied
                ? 'bg-green-600 text-white'
                : 'bg-blue-600 hover:bg-blue-700 text-white'
            }`}
            disabled={copied}
          >
            {copied ? (
              <>
                <Check className="w-5 h-5" />
                ¡Copiado!
              </>
            ) : (
              <>
                <Copy className="w-5 h-5" />
                Copiar al Portapapeles
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CopyUrlModal;